import { cva } from 'class-variance-authority';
import { useUIStore } from '@/stores/use-ui-store';
import { Text } from '@nula/core-ui';
import styles from './status-bar.module.css';

const statusBar = cva(styles.base);

export function StatusBar() {
  const isVisible = useUIStore((s) => s.isStatusBarVisible);
  const { wordCount, characterCount } = useUIStore((s) => s.editorStats);
  const readTime = Math.max(1, Math.ceil(wordCount / 200));

  if (!isVisible) return null;

  return (
    <Text
      size="xs"
      type="secondary"
      aria-live="polite"
      aria-atomic="true"
      className={statusBar()}
    >
      {wordCount} words / {characterCount} characters / {readTime} min read
    </Text>
  );
}
